import { render, staticRenderFns } from "./ResetPasswordModal.vue?vue&type=template&id=6110df84&scoped=true&"
import script from "./ResetPasswordModal.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordModal.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordModal.vue?vue&type=style&index=0&id=6110df84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6110df84",
  null
  
)

export default component.exports